
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HintComponent } from "@shared-angular/components/hint/hint.component";
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TextareaModule } from 'primeng/textarea';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { FormForBooleanComponent } from 'src/app/shared/components/ai-bot/utils/form-for-boolean/form-for-boolean.component';
import { SubmenuComponent } from 'src/app/shared/components/submenu/submenu.component';
import { SubmenuserviceService } from 'src/app/shared/components/submenu/submenuservice.service';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { CodemirrorCssComponent } from "../../../../../../../shared/components/ai-bot/utils/codemirror-css/codemirror-css.component";
import { ManualLinkComponent } from "../../../../../../../shared/components/rag-admin/manual-link/manual-link.component";
import { isReasoningModel, reasoningEffortOptions } from './../../../../../../../../../../shared/src/ChatbotConfig';

@Component({
  imports: [FormsModule, FormForBooleanComponent, TooltipModule, CodemirrorCssComponent, HintComponent, ManualLinkComponent, SubmenuComponent, CardModule, DialogModule, InputTextModule, InputNumberModule, SelectModule, TableModule, TextareaModule, ToggleSwitchModule, ButtonModule],
  templateUrl: './chatbot-tab.component.html',
  styleUrl: './chatbot-tab.component.scss'
})
export class ChatbotTabComponent {
  protected gptSelectableVoices: string[] = ['alloy', 'ash', 'nova', 'shimmer', 'echo', 'onyx', 'fable', 'sage', 'coral'];
  public readonly isReasoningModel = isReasoningModel;



  //i18n
  public humanFeedback = $localize`:@@active-human-feeback:Menschliches Feedback aktivieren`;
  public showPrompt = $localize`:@@show-prompt:Chat-Eingabezeile anzeigen`;
  public voiceInput = $localize`:@@voice-input:Spracheingabe`;
  public redirectAvatar = $localize`:@@redirect-avatar:Wechseln zu Avatar`;
  public redirectVoice = $localize`:@@redirect-to-voice:Wechseln zu Voice`;
  public cancelThinking = $localize`:@@cancel-thinking:Bot-Denken abbrechen`;
  public enterCustomCss = $localize`:@@enter-custom-css:Gib deinen CSS-Code hier ein…`;
  public copyMessage = $localize`:@@copy-message:Nachricht kopieren`;
  public deleteMessage = $localize`:@@delete-message:Nachricht löschen`;
  public clearChatDescription = $localize`:@@clear-chat-description:Chatbot immer von Anfang starten`;
  public voiceOutput = $localize`:@@voice-output:Sprachausgabe`;
  public activateReasoning = $localize`:@@reasoning:Reasoning`;
  public activateWebSearch = $localize`:@@web-search:Websuche`;
  public activateUserDocuments = $localize`:@@user-documents-enable:Nutzer-Dokumente aktivieren`;
  public userDocumentsMemoryLabel = $localize`:@@doc-search-memory:Ergebnisse fr\u00fcherer Suchen merken`;
  public isTemplateVarHtmlEditorVisible = false;
  public templateVarHtmlEditorValue = '';
  public templateVarHtmlEditorIndex: number | null = null;
  public templateVarTypes = [
    { label: 'Text', value: 'string' },
    { label: 'Zahl', value: 'number' },
    { label: 'Boolean', value: 'boolean' }
  ];

  //end

  @ViewChild('chatbot') public chatbot!: ElementRef<HTMLIFrameElement>;

  constructor(public rss: RouteShareService, public submenuService: SubmenuserviceService) { }

  protected getReasoningEffortOptions() {
    return reasoningEffortOptions.filter(
      option => option.supported.includes(this.rss.botConfig.model) || option.value === null
    );
  }

}
